import React, { Fragment, useEffect } from 'react';

import PanelContainer from '../../components/PanelContainer';
import { useAppSelector, useAppDispatch } from '../../hooks/useRedux';
import { appsActions, list, listLoaded } from '../../redux/reducers/apps';
import { HeadWrapper } from '../../elements';

import AppList from './AppList';
import CreateFirstApp from './CreateFirstApp';
import CreateAppModal from './CreateAppModal';

function AppPage(props) {
  const dispatch = useAppDispatch();
  const appList = useAppSelector(list);
  const appListLoaded = useAppSelector(listLoaded);

  useEffect(() => {
    dispatch(appsActions.loadAppList());
  }, [dispatch]);

  return (
    <Fragment>
      <HeadWrapper
        href="https://developer.staq.io/apps"
      />
      <PanelContainer />
      <CreateAppModal />
      {appListLoaded && !!appList && !!appList.length && (
        <AppList appList={appList} />
      )}
      {appListLoaded && !!appList && !appList.length && (
        <CreateFirstApp />
      )}
    </Fragment>
  );
}

export default AppPage;
